// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3hoW9","clinicsSelect":"TableHeading_clinicsSelect__15LOH"};